import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { NavLink } from 'react-router-dom';

import { Icon, Image, Button, Dropdown } from 'semantic-ui-react';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import { CtServiceShareSelect, CtHeaderExam, CtHeaderTarget, CtStartExam, CtStartEdu } from 'containers';
import { Logo, ButtonLink, ModalTemplate, TimerSessionCheck } from 'components';

import classNames from 'classnames/bind';
import styles from './Header.css';
const cx = classNames.bind(styles);

class Header extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let curLanguage = '한국어';
    if (localStorage.getItem('language') === 'ko') {
      curLanguage = '한국어';
    } else if (localStorage.getItem('language') === 'ja') {
      curLanguage = '日本語';
    } else if (localStorage.getItem('language') === 'en') {
      curLanguage = 'English';
    }
    if (commonVar.isJapan === 1) {
      if (localStorage.getItem('language') === 'en') {
        curLanguage = 'English';
      } else {
        curLanguage = '日本語';
      }
    }

    const { isAuth, user, onLoginPage, onLogout } = this.props;
    const { isModal, onToggleModal } = this.props;

    // 비활성화 사용자 알림
    let userAuthTime;
    if (!!user) {
      const userAuthDate = common.timeDiffFromUTCEpoch(user.regEpoch + 259200);

      if (!!userAuthDate) {
        userAuthTime = (
          <div>
            <Image className="userActived-icon" src={'/img/common/mail_auth.png'} />
            <div className={cx('userActived-info')}>
              <div className={cx('userActived-info-con')}>
                {defineMessages(formatMessage({ id: 'Header_7', defaultMessage: '사용자 인증 만료 기간이' })) +
                  ' ' +
                  userAuthDate +
                  ' ' +
                  defineMessages(formatMessage({ id: 'Header_8', defaultMessage: '남았습니다.' }))}
                <span>
                  {'* ' +
                    defineMessages(
                      formatMessage({ id: 'Header_10', defaultMessage: '가입 인증 메일을 통해 계정을 활성화하세요.' })
                    )}
                </span>
                <div className={cx('userActived-info-tail')} />
              </div>
            </div>
          </div>
        );
      } else {
        userAuthTime = (
          <div>
            <Image className="userActived-icon" src={'/img/common/mail_auth.png'} />
            <div className={cx('userActived-info')}>
              <div className={cx('userActived-info-con')}>
                {defineMessages(
                  formatMessage({ id: 'Header_9', defaultMessage: '사용자 인증 기간이 만료되었습니다.' })
                )}
                <span>
                  {'* ' +
                    defineMessages(
                      formatMessage({ id: 'Header_10', defaultMessage: '가입 인증 메일을 통해 계정을 활성화하세요.' })
                    )}
                </span>
                <div className={cx('userActived-info-tail')} />
              </div>
            </div>
          </div>
        );
      }
    }

    // (Header의 우측영역) 로그인 상태
    const authRightMenu = (
      <div className={cx('right-area')}>

        <TimerSessionCheck />
        <Dropdown
          className="bt-icon icon"
          pointing="top right"
          trigger={
            <div className={cx('icon-wrap', user && user.userActived === 0 ? 'userActived-wrap' : '')}>
              <div className={cx('icon-image-wrap')}>
                <Image className="help-image" src={'/img/common/icon_help.png'} />
              </div>
            </div>
          }>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => onToggleModal('mudfixInfo')}>
              {defineMessages(formatMessage({ id: 'Header_6', defaultMessage: 'MudFix 정보' }))}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setTimeout(() => {
                  if (curLanguage === '日本語') {
                    window.location.href = '/fdata/serve/Mudfix_V1.0_Manual_japan.pdf';
                  } else {
                    window.location.href = '/fdata/serve/MudFix_V1.0_Manual.pdf';
                  }
                }, 100);
              }}>
              {defineMessages(formatMessage({ id: 'Header_11', defaultMessage: '사용자 매뉴얼' }))}
            </Dropdown.Item>

          </Dropdown.Menu>
        </Dropdown>
        <Dropdown
          className="bt-icon icon"
          pointing="top right"
          trigger={
            <div className={cx('icon-wrap', user && user.userActived === 0 ? 'userActived-wrap' : '')}>
              <div className={cx('icon-image-wrap')}>
                <Image className="setting-image" src={'/img/common/icon_setting.png'} />
              </div>
            </div>
          }>
          <Dropdown.Menu>
            <ButtonLink activeOnlyWhenExact={false} to="/main/mypage/smtp" label={'SMTP'} />
            {user &&
              user.serviceNo === user.originalServiceNo && (
                <ButtonLink
                  activeOnlyWhenExact={false}
                  to="/main/mypage/share"
                  label={defineMessages(formatMessage({ id: 'MyPageMenu_4', defaultMessage: '서비스 공유' }))}
                />
              )}
            {commonVar.isEdu === 1 && (
              <ButtonLink
                activeOnlyWhenExact={false}
                to="/main/mypage/edu"
                label={defineMessages(formatMessage({ id: 'MyPageMenu_10', defaultMessage: '교육설정' }))}
              />
            )}
            {commonVar.isDeclare === 1 && (
              <ButtonLink
                activeOnlyWhenExact={false}
                to="/main/mypage/declare"
                label={defineMessages(formatMessage({ id: 'MyPageMenu_9', defaultMessage: '신고설정' }))}
              />
            )}
          </Dropdown.Menu>

        </Dropdown>
        <div
          className={cx('bt-share')}
          title={defineMessages(formatMessage({ id: 'Header_1', defaultMessage: '서비스 변경' }))}>
          <CtServiceShareSelect />
        </div>
        <Dropdown
          className="bt-icon icon"
          pointing="top right"
          trigger={
            <div className={cx('icon-wrap', user && user.userActived === 0 ? 'userActived-wrap' : '')}>
              <div className={cx('icon-image-wrap')}>
                <Image className="profile-image" src={'/img/common/icon_user.png'} />
              </div>
              {user && user.userActived === 0 && userAuthTime}
            </div>
          }>
          <Dropdown.Menu>
            {user &&
              user.serviceNo === user.originalServiceNo && (
                <ButtonLink
                  activeOnlyWhenExact={false}
                  to="/main/mypage/profile"
                  label={defineMessages(formatMessage({ id: 'MyPageMenu_1', defaultMessage: '내 정보' }))}
                />
              )}
            {commonVar.isGs !== 1 && (
              <ButtonLink
                activeOnlyWhenExact={false}
                to="/main/mypage/license"
                label={defineMessages(formatMessage({ id: 'MyPageMenu_3', defaultMessage: '라이센스' }))}
              />
            )}
            <Dropdown.Divider />
            {commonVar.isJapan !== 1 && (
              <Dropdown.Item
                onClick={() => {
                  localStorage.setItem('language', 'ko');
                  window.location.reload();
                }}>
                {curLanguage === '한국어' ? <Icon name="checkmark box" /> : <Icon name="square outline" />}
                한국어
              </Dropdown.Item>
            )}
            <Dropdown.Item
              onClick={() => {
                localStorage.setItem('language', 'ja');
                window.location.reload();
              }}>
              {curLanguage === '日本語' ? <Icon name="checkmark box" /> : <Icon name="square outline" />}
              日本語
            </Dropdown.Item>
            {commonVar.isEng === 1 && (
              <Dropdown.Item
                onClick={() => {
                  localStorage.setItem('language', 'en');
                  window.location.reload();
                }}>
                {curLanguage === 'English' ? <Icon name="checkmark box" /> : <Icon name="square outline" />}
                English
              </Dropdown.Item>
            )}
            <Dropdown.Divider />
            {/* <Dropdown.Divider /> */}
            {/* <ButtonLink
              activeOnlyWhenExact={false}
              to="/main/mypage/examtemplate"
              label={defineMessages(formatMessage({ id: 'MyPageMenu_2', defaultMessage: '훈련 템플릿' }))}
            /> */}

            <Dropdown.Item className={cx('text-align-center')} onClick={onLogout}>
              Logout
            </Dropdown.Item>

            {/* {localStorage.getItem('language') === 'ko' && (
              <ButtonLink
                activeOnlyWhenExact={false}
                to="/main/mypage/release"
                label={defineMessages(formatMessage({ id: 'MyPageMenu_6', defaultMessage: '릴리즈 노트' }))}
              />
            )} */}
          </Dropdown.Menu>
        </Dropdown>

      </div>
    );

    // (Header의 우측영역) 로그인 안된상태
    const nonAuthRightMenu = (
      <div className={cx('right-area')}>
        <Dropdown className="icon select-language" button floating labeled icon="world" text={curLanguage}>
          <Dropdown.Menu>
            {commonVar.isJapan !== 1 && (
              <Dropdown.Item
                text="한국어"
                onClick={() => {
                  localStorage.setItem('language', 'ko');
                  window.location.reload();
                }}
              />
            )}
            <Dropdown.Item
              text="日本語"
              onClick={() => {
                localStorage.setItem('language', 'ja');
                window.location.reload();
              }}
            />
            {commonVar.isEng === 1 && (
              <Dropdown.Item
                text="English"
                onClick={() => {
                  localStorage.setItem('language', 'en');
                  window.location.reload();
                }}
              />
            )}
          </Dropdown.Menu>
        </Dropdown>

        <div className={cx('header-link')}>
          <ButtonLink
            onClick={onLoginPage}
            activeOnlyWhenExact={false}
            to="/login"
            label={defineMessages(formatMessage({ id: 'Header_2', defaultMessage: '로그인' }))}
          />
        </div>
        {/* 서비스 가입 - 구축형의 경우 서비스 가입 제한*/}
        {commonVar.isSaas === 1 ? (
          <div className={cx('header-link')}>
            <ButtonLink
              activeOnlyWhenExact={false}
              to="/register"
              label={defineMessages(formatMessage({ id: 'Header_3', defaultMessage: '서비스 가입' }))}
            />
          </div>
        ) : (
            <div />
          )}
      </div>
    );

    return (
      <div className={cx('header-wrapper')}>
        {isModal === 'mudfixInfo' && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            visible
            className={cx('modal-mudfixInfo', 'common-content')}
            onToggleModal={onToggleModal}
            closeIcon={<Image src="/img/common/close_black.png" className={cx('bt-startExam-close icon')} />}>
            <div className={cx('bold font-size-20')}>
              <span className={cx('inline-block mr-5')}>
                <Image src={'/img/logo/mf_logo_large.png'} />
              </span>
              V1.0
            </div>
            <div className={cx('mt-20 bold')}>MudFix Manager: V1.0</div>
            <div className={cx('mt-5 bold')}>MudFix Attach: V1.0</div>
            {commonVar.isGs !== 1 && (
              <div className={cx('mt-5 bold')}>MudFix Update Version: {commonVar.updateVersion}</div>
            )}

            {localStorage.getItem('language') !== 'ja' ? (
              <div className={cx('mt-15 font-size-12')}>Copyright©JiranSecurity. All rights reserved.</div>
            ) : (
                <div className={cx('mt-15 bold font-size-11 white')}>
                  <a href="https://www.jsecurity.co.jp/">© 2018 株式会社 JSecurity</a>
                </div>
              )}
          </ModalTemplate>
        )}
        <div className={cx('mainMeun-area')}>
          <div className={cx('mainMeunInner')}>
            <div className={cx('logo-area')}>
              <div className={cx('logo-inner')}>
                {/* <div
                  className={cx('logo-link')}
                  onClick={() => {
                    // window.location.reload();
                  }}>
                  <Logo color="white" />
                </div> */}
                <NavLink to="/main/dashboard" className={cx('logo-link')}>
                  <Logo color="white" />
                </NavLink>
              </div>
            </div>
            <div className={cx('content-area')}>
              {isAuth === 1 ? (
                <div className={cx('left-area')}>
                  <div className={cx('left-inner-button')}>
                    <CtStartExam />
                    {!!commonVar.isEdu && <CtStartEdu />}
                    <div className={cx('link-area')}>
                      {/* <NavLink exact to="/main/dashboard" className="item" activeClassName="active">
                        대시보드
                      </NavLink> */}
                      <NavLink to="/main/exam" className={cx('item')} activeClassName="active" >
                        {defineMessages(formatMessage({ id: 'Header_4', defaultMessage: '훈련결과' }))}
                      </NavLink>
                      {commonVar.isEdu === 1 && (
                        <NavLink to="/main/edu" className={cx('item')} activeClassName="active">
                          {defineMessages(formatMessage({ id: 'Header_12', defaultMessage: '교육결과' }))}
                        </NavLink>
                      )}
                      {commonVar.isDeclare === 1 && (
                        <NavLink to="/main/declaration" className={cx('item')} activeClassName="active" >
                          {defineMessages(formatMessage({ id: 'Header_13', defaultMessage: '신고결과' }))}
                        </NavLink>
                      )}
                      <NavLink to="/main/target" className={cx('item')} activeClassName="active" >
                        {defineMessages(formatMessage({ id: 'Header_5', defaultMessage: '대상관리' }))}
                      </NavLink>
                      <NavLink to="/main/allTemplate" className={cx('item')} activeClassName="active" >
                        {defineMessages(formatMessage({ id: 'Header_14', defaultMessage: '템플릿관리' }))}
                      </NavLink>
                    </div>
                  </div>
                </div>
              ) : (
                  commonVar.isGs !== 1 && (
                    <div className={cx('left-area')}>
                      <div className={cx('left-inner-button')}>
                        <div className={cx('link-area')}>
                          <NavLink exact to="/intro" className={cx('item')} activeClassName="active">
                            MudFix
                        </NavLink>
                          <NavLink to="/intro/faq" className={cx('item')} activeClassName="active">
                            FAQ
                        </NavLink>
                          {/* <NavLink to="/intro/price" className={cx('item')} activeClassName="active">
                          License
                        </NavLink> */}
                          {/* 구축형 */}
                          {/* {commonVar.isSaas === 0 && (
                          <NavLink to="/intro/price" className={cx('item')} activeClassName="active">
                            License
                          </NavLink>
                        )} */}
                        </div>
                      </div>
                    </div>
                  )
                )}
              {isAuth === 1 ? authRightMenu : nonAuthRightMenu}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  isAuth: PropTypes.number,
  onMudfixInfo: PropTypes.func,
  onLogout: PropTypes.func
};

Header.defaultProps = {
  user: {}
};

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/script/components/header/Header.js